module.exports = __webpack_public_path__ + "static/media/price-icon101.23d0a58a.png";